import { CustomMiddlewareOptions } from './types';

/**
 * Defines the defaults options for the api middleware.
 */
export const defaultMiddlewareOptions: CustomMiddlewareOptions = {
  clientName: 'default'
};
